<template lang="html">
  <div class="table_card" v-if="charged">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Editar tag</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              @click="$router.push({name: 'tag'})"
              class="breadcums__option"
            >
              Tags
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Editar tag
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex lg3 class="filter_options">
          <v-flex class="right mr-1">
            <button
              class="faccess_button px-5"
              @click="editTag()"
            >
              Guardar
            </button>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <v-flex lg7 xs12>
        <span class="table_card__info--label">Nombre</span>
        <input
          class="faccess_input"
          type="text"
          placeholder="Nombre"
          v-model="tag.attributes.natural_name"
        >
      </v-flex>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      tag: '',
      charged: false
    }
  },
  mounted(){
    var path = this.$route.path.split('/')
    try {
      this.$http.get('tags/'+ path[2],
      {headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}}
      ).then(function(response){
        this.tag = response.body.data
        this.charged = true
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods: {
    editTag(){
      try {
        this.$http.patch('tags/'+ this.tag.id, {data: this.encrypt(this.tag).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          this.$router.push({name: 'tag'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/tags/Edit_tag.vue